$(document).ready(() => {
  const currentLocale = getCurrentLocale();
  const $exportSubscriptionBtn = $('.exportProfilesBtn');

  if ($exportSubscriptionBtn.length === 0) { return null }

  const $exportsSection = $('#profile_exports');

  const $newExportContainer = $('.export-entries');
  const downloadTranslation = {
    'download': {
      'fr': 'Télécharger',
      'en': 'Download',
      'es': 'Descargar',
    },
    'in_progress': {
      'fr': 'En cours de chargement',
      'en': 'Loading',
      'es': 'Cargando',
    },
    'failed': {
      'fr': 'Erreur de chargement',
      'en': 'Loading error',
      'es': 'Error de carga',
    },
  };

  const scrollToTable = () => {
    $('html, body').animate({
      scrollTop: $('.export-entries').offset().top
    }, 1000);
  }

  const addNewExportRow = (exportId, exportData) => {
    const new_export_row =
      `<tr id='newExportRow${exportId}'>
        <td class='export-date'>
            ${$exportSubscriptionBtn.data('current-date')}
          </td>
          <td class='export-status'>
            ${exportData.status}
          </td>
          <td class='export-document'>
            <div class='spinner-bar'>
              ${$exportSubscriptionBtn.data('spinner-image')}
            </div>
          </td>
        </tr>`;
    $newExportContainer.prepend(new_export_row);
  }

  const displayExportsSection = () => {
    if ($exportsSection.hasClass('d-none')) { $exportsSection.removeClass('d-none') }
  }

  if ($exportSubscriptionBtn.length) {
    $exportSubscriptionBtn.on('click', () => {
      scrollToTable();
    });
  }

  App.cable.subscriptions.create(
    { channel: 'AssetManagementAdvisors::ExportProfilesChannel',
      profile_id: $exportSubscriptionBtn.data('profile-id')
     }, {
      received(data) {
        if (data.generating) {
          displayExportsSection();

          addNewExportRow(data.export_id, data);
        } else if (data.success) {
          export_url = data.export_url;
          const $newExportRowEl = $(`#newExportRow${data.export_id}`);

          $newExportRowEl.find('.export-date').html(data.created_at);
          $newExportRowEl.find('.export-type').html(data.type);
          $newExportRowEl.find('.export-status').html(data.status);

          const $downloadLink = $newExportRowEl.find('.export-document');
          $downloadLink.html(`<a href='${export_url}' target='_blank' rel= 'noopener noreferrer nofollow'>${downloadTranslation['download'][currentLocale]}</a>`);
        } else {
          const $newExportRowEl = $(`#newExportRow${data.export_id}`);
          $newExportRowEl.find('.export-document .spinner-bar').remove();
          $newExportRowEl.find('.export-date').html(data.created_at);
          $newExportRowEl.find('.export-type').html(data.type);
          $newExportRowEl.find('.export-status').html(downloadTranslation['failed'][currentLocale]);
          $newExportRowEl.find('.export-document').html(`<img src='${data.failed_icon_url}' height='30' class='me-2' />`)
        }
      }
    }
  );
});
